import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';

@Component({
    selector: 'tt-purch-planning-overview',
    templateUrl: './purch-planning-overview.component.html',
    styleUrls: ['./purch-planning-overview.component.css'],
})
export class PurchPlanningOverviewComponent implements OnInit {
    public get?: PurchPlanningOverviewGet;

    public stockplaces: StockplaceItem[] = [];

    public planningGrid?: GridOptions;

    public receivedGrid?: GridOptions;

    public purchOrderNoButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', onClick: () => this.readGrid(), type: 'primary' }];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {}

    public readGrid() {
        if (this.get?.tab === 'planning') {
            if (!this.planningGrid) {
                this.buildPlanningGrid();
            } else {
                this.planningGrid.gridfunc?.read();
            }
        } else if (this.get?.tab === 'received') {
            if (!this.receivedGrid) {
                this.buildReceivedGrid();
            } else {
                this.receivedGrid.gridfunc?.read();
            }
        }
    }

    private buildPlanningGrid() {
        if (!!this.get) {
            this.planningGrid = new Grid().setRememberId('w_purchplanningoverview.planning_grid').setLoadDataFunction({ method: 3695, parameters: () => this.get });
        } else {
            throw Error('get must be retrieved before planning grid can be initialised.');
        }
    }

    private buildReceivedGrid() {
        if (!!this.get) {
            this.receivedGrid = new Grid().setRememberId('w_purchplanningoverview.received_grid').setLoadDataFunction({ method: 3696, parameters: () => this.get });
        } else {
            throw Error('get must be retrieved before recieved grid can be initialised.');
        }
    }

    private async loadStockplaces() {
        this.stockplaces = await this.logistic.getStockplaces({ add_all: '0' });
    }

    private async loadGet() {
        try {
            this.get = (await this.datatask.Post(3694))[0];
        } catch (error) {
            console.error(error);
        }
    }

    private async initPage() {
        this.loadStockplaces();
        await this.loadGet();

        if (this.get?.tab === 'planning') {
            this.buildPlanningGrid();
        } else if (this.get?.tab === 'received') {
            this.buildReceivedGrid();
        }
    }

    ngOnInit(): void {
        this.initPage();
    }
}

interface PurchPlanningOverviewGet {
    stockplace_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    tab: string;
    purch_order_no: string;
    show_setting: '1' | '0';
}
